import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {HeaderService} from '../../core/services/header.service';
import {MenuModel} from '../../core/models/menu.model';
import { MatIconAnchor } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { FlexModule } from '@angular/flex-layout';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'app-new-apps-popup',
    templateUrl: './apps-popup.component.html',
    styleUrls: ['./apps-popup.component.scss'],
    standalone: true,
    imports: [MatIconAnchor, MatTooltip, MatMenuTrigger, MatIcon, MatMenu, FlexModule, NgFor, NgIf, MatMenuItem, RouterLink, MatBadge]
})
export class AppsPopupComponent implements OnInit, OnDestroy {

  apps: MenuModel[] = [];

  constructor(public headerService: HeaderService, private authService: AuthService) {
    authService.currentUser.subscribe(user => {
      this.apps = this.headerService.getUserApps().filter(x => !x.forceHideApp);
    });
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {

  }
}
